import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Output, Input, Component, NgModule } from '@angular/core';
import * as i1 from '@azavista/components/shared';
import { TimeType, AzavistaSharedModule } from '@azavista/components/shared';
import * as i3 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import * as i4 from '@ngx-translate/core';
let AzavistaDurationService = /*#__PURE__*/(() => {
  class AzavistaDurationService {
    getMaxDuration(seconds) {
      if (seconds <= 0) {
        return {
          type: TimeType.s,
          value: 0
        };
      }
      const item = this.getSecondsMap().find(x => seconds % x.seconds === 0);
      const duration = {
        type: item.timeType,
        value: seconds / item.seconds
      };
      return duration;
    }
    getSecondsMap() {
      if (this.secondsMap) {
        return this.secondsMap;
      }
      this.secondsMap = [{
        timeType: TimeType.w,
        seconds: 604800
      }, {
        timeType: TimeType.d,
        seconds: 86400
      }, {
        timeType: TimeType.h,
        seconds: 3600
      }, {
        timeType: TimeType.m,
        seconds: 60
      }, {
        timeType: TimeType.s,
        seconds: 1
      }];
      return this.secondsMap;
    }
    static {
      this.ɵfac = function AzavistaDurationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaDurationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaDurationService,
        factory: AzavistaDurationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaDurationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaDurationComponent = /*#__PURE__*/(() => {
  class AzavistaDurationComponent {
    constructor(transSvc, durationSvc) {
      this.transSvc = transSvc;
      this.durationSvc = durationSvc;
      this.seconds = 0;
      this.label = '';
      this.editMode = true;
      this.valueChanged = new EventEmitter();
      this.invalidValueSet = new EventEmitter();
    }
    ngOnInit() {
      this.seconds ||= 0;
      this.secondsMap = this.durationSvc.getSecondsMap();
      this.durationTimes = this.createDurationTimes();
      this.duration = this.durationSvc.getMaxDuration(this.seconds);
      this.fieldsData = this.createFieldsData(this.durationTimes, this.duration);
    }
    onDurationChanged(args) {
      this.duration.type = args.value.id;
      const seconds = this.getSecondsValue(this.duration);
      this.valueChanged.next(seconds);
    }
    onValueChanged(args) {
      const selectedSeconds = args.value;
      this.duration.value = selectedSeconds;
      const seconds = this.getSecondsValue(this.duration);
      this.valueChanged.next(seconds);
    }
    onInvalidValueSet(args) {
      this.invalidValueSet.next();
    }
    getSecondsValue(duration) {
      const secondsMap = this.secondsMap.find(x => x.timeType === duration.type);
      const seconds = duration.value * secondsMap.seconds;
      return seconds;
    }
    createFieldsData(allDurationTimes, duration) {
      const timeTypeFieldValue = {
        displayProperty: 'label',
        items: allDurationTimes,
        selected: allDurationTimes.find(x => x.id === duration.type)
      };
      const fieldsData = {
        value: {
          editable: true,
          schema: {
            type: 'integer',
            minimum: 0
          }
        },
        timeType: {
          field: {
            schema: {
              type: 'object'
            },
            component: "object_enum" /* FieldComponentType.objectEnum */,
            editable: true
          },
          value: timeTypeFieldValue
        }
      };
      return fieldsData;
    }
    createDurationTimes() {
      const durationTimes = [{
        id: TimeType.s,
        label: this.transSvc.getTranslation('SECONDS')
      }, {
        id: TimeType.m,
        label: this.transSvc.getTranslation('MINUTES')
      }, {
        id: TimeType.h,
        label: this.transSvc.getTranslation('HOURS')
      }, {
        id: TimeType.d,
        label: this.transSvc.getTranslation('DAYS')
      }, {
        id: TimeType.w,
        label: this.transSvc.getTranslation('WEEKS')
      }];
      return durationTimes;
    }
    static {
      this.ɵfac = function AzavistaDurationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaDurationComponent)(i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(AzavistaDurationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaDurationComponent,
        selectors: [["azavista-duration"]],
        inputs: {
          seconds: "seconds",
          label: "label",
          editMode: "editMode"
        },
        outputs: {
          valueChanged: "valueChanged",
          invalidValueSet: "invalidValueSet"
        },
        standalone: false,
        decls: 4,
        vars: 12,
        consts: [[1, "duration-container", "azavista-duration-component", "aza-cmp-flex-row", "aza-cmp-no-gap"], [3, "valueChanged", "invalidValueSet", "field", "value", "label", "editMode", "canEdit"], [3, "valueChanged", "field", "value", "label", "editMode", "canEdit"]],
        template: function AzavistaDurationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "azavista-input-field", 1);
            i0.ɵɵlistener("valueChanged", function AzavistaDurationComponent_Template_azavista_input_field_valueChanged_1_listener($event) {
              return ctx.onValueChanged($event);
            })("invalidValueSet", function AzavistaDurationComponent_Template_azavista_input_field_invalidValueSet_1_listener($event) {
              return ctx.onInvalidValueSet($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "azavista-input-field", 2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵlistener("valueChanged", function AzavistaDurationComponent_Template_azavista_input_field_valueChanged_2_listener($event) {
              return ctx.onDurationChanged($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("field", ctx.fieldsData.value)("value", ctx.duration.value)("label", ctx.label)("editMode", ctx.editMode)("canEdit", ctx.editMode);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(3, 10, "DURATION"));
            i0.ɵɵproperty("field", ctx.fieldsData.timeType.field)("value", ctx.fieldsData.timeType.value)("editMode", ctx.editMode)("canEdit", ctx.editMode);
          }
        },
        dependencies: [i3.AzavistaInputFieldComponent, i4.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AzavistaDurationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaDurationModule = /*#__PURE__*/(() => {
  class AzavistaDurationModule {
    static {
      this.ɵfac = function AzavistaDurationModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaDurationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaDurationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule, AzavistaInputFieldModule]
      });
    }
  }
  return AzavistaDurationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class IDuration {}

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaDurationComponent, AzavistaDurationModule, AzavistaDurationService, IDuration };
